/* Rquiere de mixin.js */

var socketPHP = {
   	data () {
		return {
			urlSocketPHP: 'ws://10.10.38.43:8083/',
			webSocketPHP: null,
			autoConnectionPHP: true,
			objectConnection: {
				socket: null,
				userId: 0,
				name: null,
				img: null
			},
			listResourceConections: [],
			statusConectionPHP: false
		}
	},
	computed: {
		listUsersConections() {
			let list = []
				this.listResourceConections.forEach(element => {
					let index = list.map(el => parseInt(el.userId)).indexOf(parseInt(element.userId))
					if(index == -1) {
						list.push({userId: element.userId, name: element.name, img: element.img})
					}
				});
			return list
		}
	},
	filters: {
	},
    methods:{
		analizeOrigenSystem(response) {
			switch (response.type) {
				case 'welcome':
					this.objectConnection.socket = response.socket
					this.objectConnection.userId = this.getUser.id
					this.objectConnection.name = this.getUser.name
					this.objectConnection.img = this.getUser.img
					this.sendMessageSocketPHP('sayHello')
					break;
				default:
					console.log('No esta desarrollado para este tipo (' + response.type + ')', response)
					break;
			}
		},
		analizeOrigenUser(response) {
			switch (response.type) {
				case 'sayHello':
					if(response.resource.userId == this.getUser.id) {
						console.warn('Hay otro recurso socket PHP abierto para este mismo usuario')
					} else {
						this.listResourceConections.push(response.resource)
						this.sendMessageSocketPHP('hello')
					}
					break;
				case 'hello':
					if(response.resource.userId != this.getUser.id) {
						this.listResourceConections.push(response.resource)
					}
					break;		
				case 'disconnected':
					let index = this.listResourceConections.map((el) => el.socket).indexOf(response.socket)
					if(index > -1) {
						let resourceConection = this.listResourceConections.splice(index,1)
					}
					break;			
				default:
					console.log('No esta desarrollado para este tipo (' + response.type + ')', response)
					break;
			}
		},
		sendMessageSocketPHP(type, data = null) {
			if(this.statusConectionPHP) {
				var msg = {
					resource: this.objectConnection,
					type: type,
					data: data,
				};
				console.log(JSON.stringify(msg))
				this.webSocketPHP.send(JSON.stringify(msg));	
			}
		},
		startConnectionSocketPHP() {
			this.webSocketPHP = new WebSocket(this.urlSocketPHP);
			this.webSocketPHP.onopen = (ev) => { // connection is open 
				this.statusConectionPHP = true
				console.log(this.statusConectionPHP)
				console.log('WebSocket PHP conectado!!!')
			}

			this.webSocketPHP.onmessage = (ev) => {
				let response = JSON.parse(ev.data);
				switch (response.origen) {
					case 'system':
						this.analizeOrigenSystem(response)
						break;
					case 'user':
						this.analizeOrigenUser(response)
						break;
					default:
						console.log('No esta desarrollado para este origen (' + response.origen + ')', response)
						break;
				}
			}

			this.webSocketPHP.onclose = (ev) => {
				this.statusConectionPHP = false
			}
		}
	},
};

export default socketPHP;